/**
 * Widget parrainage WLC — chargé une fois ; l’affichage est piloté côté partenaire (URL / règles internes).
 */
const WLC_SCRIPT_SRC =
    'https://dj8z0bra0q3sp.cloudfront.net/js/referral/register-box.js'

const SCRIPT_MARKER = 'data-wlc-referral-box'

const InitWlcReferralWidget = () => {
    if (typeof document === 'undefined') return
    if (document.querySelector(`script[${SCRIPT_MARKER}]`)) return

    window.wlcOptions = {
        dataKey: '21f9d2c4098c79a1a2f3d193a59184b3',
        dataWidgetConfig: '8DL6PWS0',
        dataFields: 'name,email,firstname',
    }

    const s = document.createElement('script')
    s.async = true
    s.src = WLC_SCRIPT_SRC
    s.setAttribute(SCRIPT_MARKER, '1')
    document.head.appendChild(s)
}

export { InitWlcReferralWidget }
